
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useCommunicationSetupSlice } from 'features/CommunicationSetup/slice';
import { useAuth } from 'core/context/AuthContext/AuthContextProvider';
import EncryptedStorage from 'core/utils/constants/encryptedStorage';
import isEmpty from "lodash/isEmpty";

export const useSocialHubEvents = () => {
    const dispatch = useDispatch();
    const { actions: commActions } = useCommunicationSetupSlice();
    const authData = useAuth();

    useEffect(() => {
        const channel = new BroadcastChannel('popup_channel');

        channel.onmessage = (event) => {
            if (event.data) {
                let payload: any = {};
                try {
                    payload = JSON.parse(event.data);
                } catch (err) { }

                let SSMedia: any = {};
                try {
                    SSMedia = JSON.parse(EncryptedStorage.getItem('selectedSocialMedia') as any);
                } catch (err) { }

                if (SSMedia?.NAME === 'Instagram') {
                    payload = {
                        ...payload,
                        URL: 'instagram/accounts'
                    };
                } else if (['Google Business', 'Youtube']?.includes(SSMedia?.NAME)) {
                    payload = {
                        ...payload,
                        DATA: {
                            ...payload.DATA,
                            SERVICE: SSMedia?.id
                        }
                    };
                }

                if (!isEmpty(payload)) {
                    dispatch(commActions.fetchCommunicationSetupListStart({ ...payload, authData }));
                }
            }
        };

        return () => {
            channel.close();
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
